import React from "react";
import { replaceCommas, textSubStr } from "../hooks/basicFunc";
import styled from "styled-components";
import NoHistory from "./NoHistory";
// const data = [
//   {
//     serviceName: "타보소",
//     date: "2023.06.19 16:10:10",
//     point: -10,
//   },
//   {
//     serviceName: "타보소",
//     date: "2023.06.19 16:10:10",
//     point: -10,
//   },
//   {
//     serviceName: "타보소",
//     date: "2023.06.19 16:10:10",
//     point: -10,
//   },
//   {
//     serviceName: "타보소",
//     date: "2023.06.19 16:10:10",
//     point: -10,
//   },
//   {
//     serviceName: "타보소",
//     date: "2023.06.19 16:10:10",
//     point: -10,
//   },
//   {
//     serviceName: "타보소",
//     date: "2023.06.19 16:10:10",
//     point: -10,
//   },
//   {
//     serviceName: "타보소",
//     date: "2023.06.19 16:10:10",
//     point: -10,
//   },
//   {
//     serviceName: "타보소",
//     date: "2023.06.19 16:10:10",
//     point: -10,
//   },
//   {
//     serviceName: "타보소",
//     date: "2023.06.19 16:10:10",
//     point: -10,
//   },
//   {
//     serviceName: "타보소",
//     date: "2023.06.19 16:10:10",
//     point: -10,
//   },
//   {
//     serviceName: "타보소",
//     date: "2023.06.19 16:10:10",
//     point: -10,
//   },
// ];
// const data = [];
const ExtinctionHistory = (props) => {
  const { data } = props;
  return (
    <>
      {Object.keys(data).length == 0 ? (
        <NoHistory />
      ) : (
        <Table>
          <thead>
            <tr>
              <th>번호</th>
              <th>소멸예정일시</th>
              <th>소멸 예정 뮤포인트</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 &&
              data.map((li, index) =>
                li.logs.map((list, index) => (
                  <tr key={index}>
                    <td>{String(index + 1).padStart(2, "0")}</td>
                    <td className="date">
                      {textSubStr(list.time)[0]}
                      <br />
                      {textSubStr(list.time)[1]}
                    </td>
                    <td className="col_pink">{replaceCommas(list.mup)}p</td>
                  </tr>
                ))
              )}
            {/* {data &&
              data.count > 0 &&
              data.logs.map((list, index) => (
                <tr key={index}>
                  <td>{String(index + 1).padStart(2, "0")}</td>
                  <td className="date">
                    {textSubStr(list.time)[0]}
                    <br />
                    {textSubStr(list.time)[1]}
                  </td>
                  <td className="col_pink">{replaceCommas(list.mup)}p</td>
                </tr>
              ))} */}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default ExtinctionHistory;
const Table = styled.table`
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.2rem;
  width: 100%;
  text-align: left;
  .date {
    font-size: 1rem;
    line-height: 1rem;
    font-weight: 400;
  }
  thead {
    height: 4.2rem;
    border-bottom: 1px solid ${({ theme }) => theme.color.black};
    th {
      line-height: 4.2rem;
    }
  }
  tr {
    :nth-child(1) {
      padding-left: 1rem;
      min-width: 8rem;
    }
    :nth-last-child(1) {
      text-align: right;
      padding-right: 1rem;
    }
  }
  tbody {
    tr {
      height: 5rem;
      border-bottom: 1px dotted #000;
    }
    :nth-last-child(1) {
      border-bottom: 0;
    }
  }
  .col_pink {
    color: ${({ theme }) => theme.color.pink};
  }
`;
